import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAccount from "src/features/account/hooks/useAccount";
import { selectConversationFileIds, useGetCallQuery } from "src/features/conversations/conversationApi";
import { useAppSelector } from "src/app/store/hooks";
import { ActionIcon, Group, Title } from "@mantine/core";
import AiInsightsPlaceholder from "src/features/conversation/AiInsightsPlaceholder";
import AiInsightsContent from "src/features/conversation/AiInsightsContent";
import { OverlayTrigger, Tooltip } from "banafo-design-system";
import { MdRefresh } from "react-icons/md";
import { useRegenerateAiInsightsMutation } from "src/features/aiAssistant/aiAssistantApi";
import { AiFailureReason, AiStatus } from "src/features/conversations/types";
import AiInsightsRemainingMessage from "src/features/conversation/AiInsightsRemainingMessage";
const AiInsights = () => {
    const { callId } = useParams();
    const { t } = useTranslation();
    const { subscriptionPlan: { isFree } } = useAccount();
    const { data: { 
    // @ts-ignore
    aiStatus, failureReason } = {}, isLoading } = useGetCallQuery(callId);
    const [regenerateAiInsights] = useRegenerateAiInsightsMutation();
    //@ts-ignore
    const fileIds = useAppSelector((state) => selectConversationFileIds(state, callId));
    const handleRetry = () => {
        regenerateAiInsights({ fileIds, id: callId });
    };
    const shouldShowRetry = 
    //this will cover automatic generation disabled case, but they want to only manually generate and server failure
    (aiStatus === AiStatus.Failed && [AiFailureReason.Disabled, AiFailureReason.General].includes(failureReason)) ||
        //this will cover old recordings
        (!aiStatus && !isLoading) ||
        // this will cover free user that updated to PRO
        (!isFree && aiStatus === AiStatus.Failed && failureReason === AiFailureReason.LimitReached) ||
        // this will cover cases when the results are not that good
        aiStatus === AiStatus.Success;
    const renderAiSection = () => {
        if (!aiStatus || isLoading) {
            if (isFree) {
                return _jsx(AiInsightsPlaceholder, { type: "update" });
            }
            return _jsx(AiInsightsContent, {});
        }
        if (aiStatus === AiStatus.Processing) {
            return _jsx(AiInsightsPlaceholder, { type: "processing" });
        }
        if (aiStatus === AiStatus.Success) {
            return _jsx(AiInsightsContent, {});
        }
        if (aiStatus === AiStatus.Failed) {
            if (failureReason === AiFailureReason.General) {
                return _jsx(AiInsightsPlaceholder, { type: "general" });
            }
            if (failureReason === AiFailureReason.Disabled) {
                return _jsx(AiInsightsPlaceholder, { type: "disabled" });
            }
            if (failureReason === AiFailureReason.LimitReached) {
                if (isFree) {
                    return _jsx(AiInsightsPlaceholder, { type: "update" });
                }
                return _jsx(AiInsightsContent, {});
            }
            return null;
        }
        return null;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Group, { mb: "md", justify: "space-between", children: [_jsx(Title, { order: 5, fw: "bold", tt: "uppercase", children: t('AI.Insights_') }), shouldShowRetry && (_jsx(OverlayTrigger, { placement: "top", overlay: _jsx(Tooltip, { id: "regenerate", children: t("Regenerate.AI.insights_") }), children: _jsx(ActionIcon, { variant: "transparent", "aria-label": "Regenerate", onClick: handleRetry, children: _jsx(MdRefresh, { size: 18 }) }) }))] }), isFree && _jsx(AiInsightsRemainingMessage, {}), renderAiSection()] }));
};
export default AiInsights;
